import { createTermsTagsManager } from '../../utils/createTermsTagsManager';
import { GARAGE_STATUSES_MAP_VALUE_TO_LABEL } from './constants';

export const garageStatusTagsManager = createTermsTagsManager({
  jsonQueryKey: 'garage_status',
  mapValueToLabel: GARAGE_STATUSES_MAP_VALUE_TO_LABEL,
  id: 'garageStatus',
});
